import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import "./style.css";
class ArticleItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      css: {},
    };
  }
  componentDidMount() {
    this.fixCss();
    window.addEventListener("resize", () => {
      this.fixCss();
    });
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this._resizeListener);
    clearTimeout(this.timeouter);
    this.setState = (state, callback) => {
      return;
    };
  }
  render() {
    const { title, hits, titleImg, articleType,hashId } = this.props;
    return (
      <NavLink to={'/articledetail/'+hashId} className="articleItem_box">
        <div
          style={this.state.css.articleItem_left}
          className="articleItem_left fl"
        >
          <div className="articleItem_box_content" dangerouslySetInnerHTML={{ __html: title }}></div>
          <div className="articleItem_box_num">
            <img
              alt=""
              className=" articleItem_num_img fl"
              src={require("../../../images/article/eye.png")}
            ></img>
            <div
              style={this.state.css.articleItem_num}
              className="articleItem_num fl"
            >
              {hits}
            </div>
            <div className="clear"></div>
          </div>
        </div>
        <div
          style={this.state.css.articleItem_right}
          className="articleItem_right fr"
        >
          <img alt="" src={titleImg}></img>
          <img
            style={{
              width: 12,
              height: 12,
              display: articleType === 2 ? "block" : "none",
            }}
            className="articleItem_right_play"
            alt=""
            src={require("../../../images/article/play.png")}
          ></img>
        </div>
        <div className="clear"></div>
      </NavLink>
    );
  }
  fixCss = () => {
    let clientWidth = document.body.clientWidth;
    let ratio = 1;
    if (clientWidth < 750) {
      ratio = clientWidth / 750;
    }
    this.setState({
      css: {
        articleItem_left: {
          width: 470 * ratio,
          marginLeft: 43 * ratio,
        },
        articleItem_right: {
          marginRight: 20 * ratio,
        },
        articleItem_num: {
          marginLeft: 10 * ratio,
        },
      },
    });
  };
}

export default ArticleItem;



// WEBPACK FOOTER //
// ./src/components/Article/ArticleItem/index.js